export type CameraCaptureBlocker = 'insecure' | 'unsupported';

export function cameraCaptureBlocker(): CameraCaptureBlocker | null {
  if (typeof window === 'undefined') {
    return null;
  }
  if (!window.isSecureContext) {
    return 'insecure';
  }
  if (!navigator.mediaDevices?.getUserMedia) {
    return 'unsupported';
  }
  return null;
}

export function localhostStudioHref(): string {
  if (typeof window === 'undefined') {
    return 'http://localhost:3001/live';
  }
  const port = window.location.port || '3001';
  return `http://localhost:${port}${window.location.pathname}${window.location.search}`;
}
